import { render, staticRenderFns } from "./TreatmentItem.vue?vue&type=template&id=7309f796"
import script from "./TreatmentItem.vue?vue&type=script&lang=js"
export * from "./TreatmentItem.vue?vue&type=script&lang=js"
import style0 from "./TreatmentItem.vue?vue&type=style&index=0&id=7309f796&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports